import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "about", label: "About" },
  { id: "menu", label: "Menu" },
  { id: "gallery", label: "Gallery" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass shadow-[0_1px_0_rgba(89,121,169,0.08)] py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="container-wide flex items-center justify-between">
        <button
          onClick={() => handleNav("hero")}
          className="flex items-center gap-3"
          data-testid="logo-button"
        >
          <img src="/images/logo.png" alt="Himalayan Cafe" className="h-12 w-12 rounded-full object-cover bg-white/80 p-1" />
          <span className="hidden sm:block font-serif-display text-xl text-[#5979A9]">
            Himalayan <span className="italic text-[#E05947]">Cafe</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => handleNav(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-[15px] tracking-wide text-[#2D3748] hover:text-[#E05947] transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#E05947] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => handleNav("contact")}
            data-testid="header-book-button"
            className="hidden md:inline-flex btn-primary !py-2.5 !px-5 !text-sm"
          >
            Book a Table
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#5979A9]"
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-[#5979A9]/10" data-testid="mobile-menu">
          <div className="container-wide py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => handleNav(l.id)}
                data-testid={`mobile-nav-${l.id}`}
                className="text-left text-lg text-[#2D3748] hover:text-[#E05947]"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("contact")}
              data-testid="mobile-book-button"
              className="btn-primary"
            >
              Book a Table
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
